<template>
  <div>
    <div class="container news-detail">
      <div class="news-title">
        <div class="tit">{{ $hs(newDetailData.title,newDetailData.enTitle,newDetailData.threeTitle) }}</div>
        <div class="date">{{$t('GA.ReleaseDate')}}：{{ newDetailData.createdTime }}</div>
      </div>
      <!-- <div style="margin:0 0 10px 0;">{{ $hs(newDetailData.description,newDetailData.enDescription,newDetailData.threeDescription)||'' }}</div>
      <div class="img">
        <img :src="newDetailData.imgUrl" alt srcset />
      </div> -->
      <div class="html-content" v-html="$hs(newDetailData.content,newDetailData.enContent,newDetailData.threeContent)||''"></div>
    </div>
  </div>
</template>
<script>
import { GetDetail, queryPageByNewsList } from '@/api/news'
import { mapState, mapGetters } from 'vuex'
import transformMark from '@/utils/water'
export default {
  name: 'detail',
  components: {},
  data() {
    return {
      dialogVisible: false,
      videoUrl: '',
      recommendList: [],
      groupList: [],
      videoList: [],
      newDetailData: {},
      queryParam: {
        client_Nu: '',
        pageNo: 1,
        pageSize: 8,
        sortField: '',
        sortOrder: '',
        keywords: '',
        newsId: 0
      },
      totalRows: 0
    }
  },
  computed: {
    ...mapState('user', ['userInfo']),
    ...mapGetters('setting', {
      getSetting: 'get_setting'
    })
  },
  created() {
    this.initData()
  },
  methods: {
    initData() {
      const loading = this.$loading({
        lock: true,
        text: this.$t('GA.loading'),
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.queryParam.client_Nu = this.userInfo.client_Nu || ''
      this.queryParam.newsId = Number(this.$route.query.num)
      // 推荐产品
      queryPageByNewsList(this.queryParam)
        .then(res => {
          if (res.success) {
            this.recommendList = res.data.rows || []
            this.queryParam.pageNo = res.data.pageNo
            this.queryParam.pageSize = res.data.pageSize
            this.totalRows = res.data.totalRows
            this.queryParam.totalPage = res.data.totalPage
            this.recommendList.forEach(item => {
              transformMark(item.imgUrl + '?imageMogr2/thumbnail/800x').then(result => {
                item.imgUrl = result
              })
            })
          } else {
            this.$message.error(res.message)
          }
        })
        .catch(err => {
          this.$message.error(err)
        })

      // 渲染html
      GetDetail({ id: this.$route.query.num })
        .then(res => {
          if (res.success) {
            this.newDetailData = res.data || {}
            let date = ''
            date = new Date(this.newDetailData.createdTime)
            let year = date.getFullYear()
            let month = date.getMonth() + 1
            let d = date.getDate()
            this.newDetailData.createdTime = year + '-' + month + '-' + d
          } else {
            this.$message.error(res.message)
          }
        })
        .catch(err => {
          this.$message.error(err)
        })
        .finally(() => {
          loading.close()
        })
    },
    // 分页大小操作
    handleSizeChange(pageSize) {
      this.queryParam.pageNo = 1
      this.queryParam.pageSize = pageSize
      this.initData()
    },
    // 分页翻页操作
    handleCurrentChange(pageNo) {
      // sessionStorage.setItem('activePageNo', pageNo)
      this.queryParam.pageNo = pageNo
      this.initData()
    }
  }
}
</script>
<style lang="scss" scoped>
.news-detail {
  min-height: 600px;
  padding: 50px 0 40px;
  .img {
    margin: 40px 0;
    display: flex;
    justify-content: center;
    img{
      max-width: 1200px;
    }
  }
}

.news-title {
  display: flex;
  flex-direction: column;
  align-items: center;
  .tit {
    min-height: 50px;
    font-size: 24px;
    color: #222222;
  }
  .date {
    font-size: 12px;
    color: #666666;
    margin: 0 0 20px 0;
  }
}

.product-recommend {
  width: 100%;
  padding: 40px 0;
}

.video-center {
  background-color: #f5f5f5;

  .title {
    font-size: 24px;
    font-weight: bold;
    color: #666666;
    padding: 30px 0 20px 0;
  }
  .video-box {
    display: flex;
    flex-wrap: wrap;
    .video-item {
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 32.2%;
      height: 270px;
      margin: 0 1.7% 20px 0;
      background-color: #474b4e;
      border-radius: 6px;
      box-shadow: 0 0 10px 3px #ddd;
      overflow: hidden;
      cursor: pointer;
      &:nth-child(3n) {
        margin-right: 0;
      }
      &:hover {
        img {
          transition-duration: 0.5s;
          transform: scale(1.1);
        }
      }
      .play {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        text-shadow: 0px 0px 8px #bbb;
        font-size: 60px;
        color: #eee;
      }
      img {
        max-width: 1200px;
        max-height: 270px;
        transition-duration: 0.5s;
      }
    }
  }
}

.nav-box {
  margin: 0 0 30px 0;
  .nav-btn {
    cursor: pointer;
    &:hover {
      color: #4a90f1;
    }
  }
}
:deep .el-dialog__body {
  max-height: 670px;
  display: flex;
  justify-content: center;
  align-content: center;
  background-color: #000;
  padding: 0 !important;
  margin: 0 20px;
}

.action-box {
  background-color: #fff;
  padding: 15px 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 15px;
  // box-shadow: 0 0 10px 3px #ddd;
  box-sizing: border-box;
}

.title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 24px;
  font-weight: bold;
  color: #666666;
  .more {
    font-size: 16px;
    font-weight: normal;
  }
}

.html-content{
  :deep(img){
    display: flex;
    margin: auto;
    max-width: 1200px;
    padding: 10px 0;

  }
}
</style>